var _path, _path2, _circle, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconMedsGray(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.32888 8.93289C4.68951 4.97096 8.05288 1.86621 12.1487 1.86621C16.2446 1.86621 19.6079 4.97096 19.9686 8.93289H20.0006V18.8262H4.29695V9.6739C4.2969 9.66246 4.29688 9.651 4.29688 9.63954C4.29688 9.62808 4.2969 9.61663 4.29695 9.60518V8.93289H4.32888Z",
    fill: "#DCDCE4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.968 23.0662C19.6073 27.0281 16.244 30.1328 12.1482 30.1328C8.05232 30.1328 4.68896 27.0281 4.32831 23.0662L4.29623 23.0662L4.29623 15.9995L12.1207 15.9995C12.1298 15.9995 12.139 15.9995 12.1482 15.9995C12.1573 15.9995 12.1665 15.9995 12.1756 15.9995L19.9999 15.9995L19.9999 22.3256C20 22.3369 20 22.3482 20 22.3595C20 22.3708 20 22.3821 19.9999 22.3934L19.9999 23.0662L19.968 23.0662Z",
    fill: "#91919C"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 21.7188,
    cy: 18.7614,
    r: 6.66667,
    transform: "rotate(-135 21.7188 18.7614)",
    fill: "url(#paint0_linear_25971_1623)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_25971_1623",
    x1: 21.7188,
    y1: 12.0947,
    x2: 21.7188,
    y2: 25.428,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5F5FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.522665,
    stopColor: "#F5F5FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.522765,
    stopColor: "#DCDCE4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DCDCE4"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMedsGray);
export default __webpack_public_path__ + "static/media/icon-meds-gray.91fc842fe83f4dbe64511d3e5fd2bcd7.svg";
export { ForwardRef as ReactComponent };